<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="table-responsive-md" style="max-height:500px; overflow-y:auto">
                <table class="table track-table table-striped table-hover">
                    <thead>
                        <tr>
                            <th class="g-color-white g-bg-main th-bordered">Select </th>
                            <th class="g-color-white g-bg-main th-bordered">E-Order# </th>
                            <th v-if="MasterAccountType == 'master' && isLastNameDesc" v-on:click="Sort('lastName', 0)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Participant Name <span class="right"><i class="fa fa-angle-double-up"></i></span></th>
                            <th v-else-if="MasterAccountType == 'master' && !isLastNameDesc" v-on:click="Sort('lastName', 1)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Participant Name <span class="right"><i class="fa fa-angle-double-up fa-rotate-180"></i></span></th>
                            <th v-if="!isSubmittedDesc" v-on:click="Sort('dateSubmitted', 0)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Submitted <span class="right"><i class="fa fa-angle-double-up"></i></span></th>
                            <th v-else v-on:click="Sort('dateSubmitted', 1)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Submitted <span class="right"><i class="fa fa-angle-double-up fa-rotate-180"></i></span></th>
                            <th v-if="!isPatientNameDesc" v-on:click="Sort('patLastName', 0)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Patient Name (Last, First) <span class="right"><i class="fa fa-angle-double-up"></i></span></th>
                            <th v-else v-on:click="Sort('patLastName', 1)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered" style="width:200px;">Patient Name (Last, First) <span class="right"><i class="fa fa-angle-double-up fa-rotate-180"></i></span></th>
                            <th v-if="!isOrderStatusDesc" v-on:click="Sort('orderStatus', 0)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Order Status/Last Update <span class="right"><i class="fa fa-angle-double-up"></i></span></th>
                            <th v-else v-on:click="Sort('orderStatus', 1)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Order Status/Last Update <span class="right"><i class="fa fa-angle-double-up fa-rotate-180"></i></span></th>
                            <th v-if="!isLabAssignmentDesc" v-on:click="Sort('orderLab', 0)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Lab Assignment <span class="right"><i class="fa fa-angle-double-up"></i></span><span style="z-index: 99999;" data-balloon="Hovering or clicking the name of the lab will display the lab address and customer service phone number (if available)"  data-balloon-pos="down" data-balloon-length="medium"><i class="fa fa-question-circle-o"></i></span></th>
                            <th v-else v-on:click="Sort('orderLab', 1)" class="g-color-white g-bg-main g-bg-main-blue--hover th-bordered">Lab Assignment <span class="right"><i class="fa fa-angle-double-up fa-rotate-180"></i></span><span style="z-index: 99999;" data-balloon="Hovering or clicking the name of the lab will display the lab address and customer service phone number (if available)"  data-balloon-pos="down" data-balloon-length="medium"><i class="fa fa-question-circle-o"></i></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isDataLoading" class="center">
                            <td v-if="MasterAccountType == 'master'" colspan="7">
                                <img src="../../../../../static/img/loading.gif">
                            </td>
                             <td v-else colspan="6">
                                <img src="../../../../../static/img/loading.gif">
                            </td>
                        </tr>
                        <tr v-if="!isDataLoading && OrderList.length > 0" v-for="(order, index) in OrderList">
                            <!-- E-Order# -->
                            <td style="text-align: center;">
                                <div class="btn-group" data-toggle="buttons">
                                    <label class="active">
                                        <input type="checkbox" name="" id="" autocomplete="off" style="transform: scale(1.3);" @change="AddToDispense($event.target.checked, index, order.orderNumber, order.orderStatus)">
                                    </label>
                                </div>
                            </td>
                            <td v-if="order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Pending - Error' && order.orderStatus != 'Exam Only'"><a href="#" v-on:click="ViewOrder(order.id)">{{order.orderNumber}}</a></td>
                            <td v-else-if="order.orderStatus == 'Exam Only'"><a href="#" v-on:click="ViewExam(order.id)">View</a></td>
                            <td v-else-if="order.orderStatus == 'Pending Approval' && MasterAccountType == 'master'"><a href="#" v-on:click="EditOrder(order.id)">EDIT</a> / <a href="#" v-on:click="ShowDeleteModal(order.id)">DELETE</a></td>
                            <td v-else-if="order.orderStatus == 'Pending Approval'"></td>
                            <td v-else-if="order.orderStatus == 'Error'"><a href="#" v-on:click="ViewOrder(order.id)">{{order.id}}</a></td>
                            <td v-else><a href="#" v-on:click="EditOrder(order.id)">EDIT</a> / <a href="#" v-on:click="ShowDeleteModal(order.id)">DELETE</a></td>
                            <!-- Patient Name (Last, First, master account) -->
                            <td v-if="MasterAccountType == 'master'">{{order.accountDetails.primaryContact.lastName}}, {{order.accountDetails.primaryContact.firstName}}</td>
                            <!-- Submitted -->
                            <td v-if="order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Error' && order.orderStatus != 'Pending - Error'">{{FormatDateToLocal(order.dateSubmitted)}}</td>
                            <td v-else></td>
                            <!-- Patient Name (Last, First, regular account) -->
                            <td>{{order.patLastName}}, {{order.patFirstName}}</td>
                            <!-- Order Status / Last Update -->
                            <td v-if="order.visionWebOrderStatus == null" class="center">{{order.orderStatus}} <br>{{FormatDateToLocal(order.dateSubmitted)}}</td>
                            <td v-else-if="order.orderStatus == 'Pending - Error'" class="center">{{order.orderStatus}} <br>{{FormatDateToLocal(order.dateSubmitted)}}</td>
                            <td v-else class="center">{{order.orderStatus}} <br> <span v-if="order.dateUpdated">{{FormatDateToLocal(order.dateUpdated)}}</span> <span v-if="order.dateUpdated == null">{{FormatDateToLocal(order.dateSubmitted)}}</span> 
                            <!-- <span> created => {{FormatDateToLocal(order.dateCreated)}}</span>
                            <span> dateUpdated => {{FormatDateToLocal(order.dateUpdated)}}</span>
                            <span> dateSubmitted => {{FormatDateToLocal(order.dateSubmitted)}}</span> -->
                            </td>
                            <!-- Lab Assignment -->
                            <td v-if="order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Pending - Error' && order.orderStatus != 'Exam Only'" v-bind:data-balloon="order.orderLab.name + ' | ' + IsEmpty(order.orderLab.shippingStreet) + ' ' + IsEmpty(order.orderLab.shippingCity) + ' ' + IsEmpty(order.orderLab.shippingStateCode) + ' ' + IsEmpty(order.orderLab.shippingPostalCode)" data-balloon-pos="left">{{order.orderLab.name}}</td>
                            <td v-else></td>
                        </tr>
                        <tr v-if="!isDataLoading && OrderList.length == 0 && MasterAccountType == 'master'">
                            <td class="center" colspan="7">No results found</td>
                        </tr>
                        <tr v-if="!isDataLoading && OrderList.length == 0 && MasterAccountType != 'master'">
                            <td class="center" colspan="6">No results found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <order-tracking-vision-web-status v-if="isStatusModalShown" @close="CloseVisionWebStatus()" :orderNumber="currentOrderNumber" :visionWebOrderStatus="currentVisionWebStatus" :dateSubmitted="currentDateSubmitted"></order-tracking-vision-web-status>
        <prompt-component :message="promptMessage" v-if="isDeleteModelShown" @close="CloseDeleteModal()" @onAgree="DeleteOrder()"></prompt-component>

    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';

import OrderTrackingVisionWebStatus from "@/components/portal/OrderTracking/OrderTrackingComponents/OrderTrackingVisionWebStatus";
    import PageLoader from "@/components/shared/HeaderComponent";
    import PromptComponent from "@/components/shared/PromptComponent";
    export default {
        components: {PromptComponent, OrderTrackingVisionWebStatus, Datepicker},
        props:['OrderList', 'DispenseList', 'PageValues', 'isDataLoading', 'SortValues', 'MasterAccountType'],
        data(){
            return{
               dateFrom:null,
               dateformat:'MM/dd/yyyy',
               orderDispenseList:[],
               isEOrderDesc:false,
               isSubmittedDesc:false,
               isPatientNameDesc:false,
               isOrderStatusDesc:false,
               isLabAssignmentDesc:false,
               isLastNameDesc:false,
               promptMessage:'Are you sure you want to delete this order?',
               isDeleteModelShown:false,
               idToDelete:null,
               br: '&#10;',
               isStatusModalShown:false,
               currentOrderNumber:null,
               currentVisionWebStatus:null,
               currentDateSubmitted:null
            }
        },
        methods: {
            AddToDispense(value, index, orderNumber, status){
                console.log(this.DispenseList);
                if(value){
                    this.DispenseList[index].dispense = true;
                } else {
                    this.DispenseList[index].dispense = false;
                }
                // console.log(this.orderDispenseList)
                this.$emit('update:DispenseList', this.DispenseList)
            },
            Sort(sortValue, sortOrder){
                this.SortValues.sortBy = sortValue;
                this.SortValues.sortOrder = sortOrder;

                if(sortValue == 'id'){
                    this.isEOrderDesc = !this.isEOrderDesc;
                }else if(sortValue == 'dateSubmitted'){
                    this.isSubmittedDesc = !this.isSubmittedDesc;
                }else if(sortValue == 'patLastName'){
                    this.isPatientNameDesc = !this.isPatientNameDesc;
                }else if(sortValue == 'orderStatus'){
                    this.isOrderStatusDesc = !this.isOrderStatusDesc;
                }else if(sortValue == 'orderLab'){
                    this.isLabAssignmentDesc = !this.isLabAssignmentDesc;
                }else if(sortValue == 'lastName'){
                    this.isLastNameDesc = !this.isLastNameDesc;
                }
                this.$emit("sort");
            },
            ShowDeleteModal(id){
                this.idToDelete = id;
                this.isDeleteModelShown = true;
            },
            CloseDeleteModal(){
                this.isDeleteModelShown = false;
            },
            DeleteOrder(){
                var _this = this;
                this.isDeleteModelShown = false;
                var params = {
                    Id: this.idToDelete
                };
                axios.post("/Order/Delete/", params, {
                    headers: { Authorization: "Bearer " + localStorage.getItem("token") }
                })
                .then(function (response) {
                    _this.$emit("delete");
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            ViewVisionWebStatus(orderNumber, status, dateSubmitted){
                this.currentOrderNumber = orderNumber;
                this.currentVisionWebStatus = status;
                this.currentDateSubmitted = dateSubmitted;
                this.isStatusModalShown = true;
            },
            CloseVisionWebStatus(){
                this.isStatusModalShown = false;
            },
            ViewOrder(id){
                //this.$router.push({name: 'OrderConfirmation',  params: {code:id, isSummaryOnly: "0"}});
                localStorage.setItem('trackorder-param','fromViewOrder');
                localStorage.setItem('url','null');
                var routeData = this.$router.resolve({name: 'OrderConfirmation', params: {code: id, isSummaryOnly: "0"}});
                window.open(routeData.href, 'newwindow', 'width=' + (parseInt(window.innerWidth)) + ', height=' + (parseInt(window.innerHeight)) + '');
            },
            ViewExam(id) {
              this.$router.push({name: 'ExamConfirmation',  params: {code:id, isSummaryOnly: '0'}});
            },
            EditOrder(id){
                localStorage.setItem('trackorder-param','null');
                localStorage.setItem('url','/Portal/Order/'+ id + '/0');
                this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 0}});
            },
            IsEmpty(param){
                if (param == null) return "";
        	    return param;
            },
            GetPortalUserId(){
                axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    localStorage.setItem("portalUserSalesforceId", response.data.raw.portalUserSalesforceId);
                })
                .catch(function (error) {
                console.log(error);
                });                
            }
        },
        created(){
            // this.GetPortalUserId();
            // console.log("OrderList created", this.OrderList)
            // this.orderDispenseList = this.DispenseList.slice();
            // this.orderDispenseList.forEach(e => {
            //     e.dispense = false
            // });
            // this.$emit('update:DispenseList', this.orderDispenseList)

        }
    }
</script>



// WEBPACK FOOTER //
// OrderTrackingTable.vue?34540ce8